// paymentsMobileApi.js — appels réseau de l'écran Paiements mobile (sortants + entrants).
// Mêmes endpoints et mêmes paramètres que PaymentSortant.tsx / PaymentEntrant.tsx.
import axios from "axios";
import { MODULE_SCOPE } from "./paymentsMobileConfig";

export async function fetchPayments(cfg, { page, limit, warehouseId, search, entityId, dateFrom, dateTo }) {
  const params = { payment_type: cfg.paymentType, page, limit };
  if (warehouseId) params.warehouse_id = warehouseId;
  if (search?.trim()) params.search = search.trim();
  if (entityId) params[cfg.listEntityParam] = entityId;
  if (dateFrom) params.date_from = dateFrom;
  if (dateTo) params.date_to = dateTo;

  const res = await axios.get("/api/payments", { params });
  return { rows: res.data?.payments || [], total: res.data?.total || 0 };
}

export async function fetchEntities(cfg, { warehouseId, companyId }) {
  const params = {};
  if (warehouseId) params.warehouseId = warehouseId;
  if (companyId) params.companyId = companyId;

  const res = await axios.get(cfg.entityPath, { params });
  const data = Array.isArray(res.data) ? res.data : res.data?.customers || res.data?.suppliers || [];
  // Les deux endpoints renvoient {id, name} (routes/users.js).
  return data.map((e) => ({ id: e.user_id || e.id, name: e.name || e.company_name || "Sans nom" }));
}

export async function fetchPaymentModes(companyId) {
  const res = await axios.get("/api/payment-modes", { params: { company_id: companyId } });
  return Array.isArray(res.data) ? res.data : res.data?.payment_modes || [];
}

export async function fetchTreasuryAccounts({ companyId, warehouseId }) {
  const res = await axios.get("/api/treasury/accounts", {
    params: {
      company_id: companyId,
      warehouse_id: warehouseId,
      include_inactive: false,
      module_scope: MODULE_SCOPE,
    },
  });
  return res.data?.success ? res.data.data || [] : [];
}

/**
 * Commandes impayées d'une entité. Le endpoint dédié renvoie un TABLEAU NU ;
 * repli sur /api/orders comme le desktop (PaymentSortant.tsx:445-450).
 */
export async function fetchUnpaidOrders(cfg, entityId, { warehouseId } = {}) {
  const params = { payment_status: "all", include_unpaid: true };
  if (warehouseId) params.warehouse_id = warehouseId;

  try {
    const res = await axios.get(cfg.unpaidPath(entityId), { params });
    if (Array.isArray(res.data) && res.data.length) return res.data;
  } catch {
    // on tente le repli ci-dessous
  }

  const fallback = await axios.get("/api/orders", {
    params: { user_id: entityId, order_type: cfg.fallbackOrderType },
  });
  const orders = fallback.data?.orders || [];
  return orders.filter((o) => Number(o.due_amount) > 0);
}

export async function fetchPaymentDetail(id) {
  const res = await axios.get(`/api/payments/${id}`);
  return res.data?.payment || res.data;
}

export function savePayment(id, payload) {
  return id ? axios.put(`/api/payments/${id}`, payload) : axios.post("/api/payments", payload);
}

export const deletePayment = (id) => axios.delete(`/api/payments/${id}`);
